import React from 'react';
// import { withStyles, makeStyles } from '@material-ui/core/styles';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
// import Paper from '@material-ui/core/Paper';
import Hidden from "@material-ui/core/Hidden";
import Box from "@material-ui/core/Box";
import { Link as RouterLink } from "react-router-dom"
import Grid from "@material-ui/core/Grid";
import Pagination from "@material-ui/lab/Pagination";
import * as globalFuncs from '../../globalFuncs/Entities/Product/Index'
// import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './style.css'

// const StyledTableCell = withStyles((theme) => ({
//     head: {
//         backgroundColor: '#950000',
//         color: '#fff',
//         [theme.breakpoints.down("sm")]: {
//             fontSize: '0.700rem',
//         }
//     },
//     body: {
//         fontSize: '1rem',
//     },
//     table: {
//         borderCollapse: 'separate !important',
//         borderSpacing: '0px 4px',
//     },
// }))(TableCell);

// const StyledTableCell2 = withStyles((theme) => ({
//     body: {
//         backgroundColor: '#fff',
//         [theme.breakpoints.down("sm")]: {
//             fontSize: '0.700rem',
//         }
//     },
// }))(TableCell);

// const StyledTableRow = withStyles((theme) => ({
//     root: {
//         boxShadow: 'none'
//     },
// }))(TableRow);

// const useStyles = makeStyles({
//     Paper: {
//         backgroundColor: 'transparent'
//     },
//     table: {
//         minWidth: 700,
//         backgroundColor: 'transparent'
//     },
// });
// const useStyles = makeStyles((theme) => ({
//     btnSearch: {
//         backgroundColor: "#417557",
//         fontWeight: "700",
//         boxShadow: "none",
//         "&:hover": {
//             backgroundColor: "#417557",
//         },
//         color: "#fff",
//     },
//     select: {
//         borderRadius: "10px",
//         width: "100%",
//         height: "34px",
//     },
//     box: {
//         [theme.breakpoints.down("sm")]: {
//             fontSize: "10px !important"
//         }
//     }
// }));

const UnPaidInvoices = ({ rows }) => {

    // const classes = useStyles();
    // const [curPage, setCurPage] = useState(1)

    return (
        <>
            <div className="invoices">
                {/* <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" style={{ borderRadius: '0px 15px 15px 0px' }}>ردیف</StyledTableCell>
                                <StyledTableCell align="center">شماره فاکتور</StyledTableCell>
                                <StyledTableCell align="center">تاریخ</StyledTableCell>
                                <StyledTableCell align="center">تعداد بسته ها</StyledTableCell>
                                <StyledTableCell align="center">مجموع</StyledTableCell>
                                <StyledTableCell align="center" style={{ borderRadius: '15px 0px 0px 15px' }}>عملیات</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, i) => (
                                <StyledTableRow key={i}>
                                    <StyledTableCell2 align="center" component="th" scope="row" style={{ borderRadius: '0px 15px 15px 0px' }}>
                                        {i + 1}
                                    </StyledTableCell2>
                                    <StyledTableCell2 align="center">{row.invoiceNumber}</StyledTableCell2>
                                    <StyledTableCell2 align="center">{row.date}</StyledTableCell2>
                                    <StyledTableCell2 align="center">{row.totalPacks}</StyledTableCell2>
                                    <StyledTableCell2 align="center">{globalFuncs.SepratePrice(row.totalSum, 'fa')}</StyledTableCell2>
                                    <StyledTableCell2 align="center" style={{ borderRadius: '15px 0px 0px 15px' }}><a href="/" rel="nofollow">نمایش</a></StyledTableCell2>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer> 
                <Table>
                        <Thead>
                            <Tr>
                                <Th>ردیف</Th>
                                <Th>شماره فاکتور</Th>
                                <Th>تاریخ</Th>
                                <Th>تعداد بسته ها</Th>
                                <Th>مجموع</Th>
                                <Th>عملیات</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {rows.map((row, i) => (
                                <Tr>
                                    <Td>{i + 1}</Td>
                                    <Td>{row.invoiceNumber}</Td>
                                    <Td>{row.date}</Td>
                                    <Td>{row.totalPacks}</Td>
                                    <Td>{globalFuncs.SepratePrice(row.totalSum, 'fa')}</Td>
                                    <Td><a href="/" rel="nofollow">نمایش</a></Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                */}

                <Box pt={4} pb={2} px={1}>
                    <Box
                        bgcolor="#950000"
                        borderRadius="10px 10px 10px 10px"
                        color="#fff"
                        p={2}
                        textAlign="center">
                        <Grid container>
                            <Hidden only={['xs']}>
                                <Grid xs={1}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">
                                        ردیف
                                    </Box>
                                </Grid>
                                <Grid xs={3}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">
                                        شماره فاکتور
                                    </Box>
                                </Grid>
                                <Grid xs={2}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">
                                        تاریخ
                                    </Box>
                                </Grid>
                                <Grid xs={2}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">
                                        تعداد بسته ها
                                    </Box>
                                </Grid>
                                <Grid xs={2}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">
                                        مجموع
                                    </Box>
                                </Grid>
                                <Grid xs={2}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">
                                        عملیات
                                    </Box>
                                </Grid>
                            </Hidden>
                            <Hidden only={['sm', 'md', 'lg', 'xl']}>
                                <Grid xs={4}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">
                                        شماره فاکتور
                                    </Box>
                                </Grid>
                                <Grid xs={4}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">تعداد بسته ها</Box>
                                </Grid>
                                <Grid xs={2}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">مجموع</Box>
                                </Grid>
                                <Grid xs={2}>
                                    <Box
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%">عملیات</Box>
                                </Grid>
                            </Hidden>
                        </Grid>
                    </Box>
                    {rows.length > 0 &&
                        rows.map((row, i) => (
                            <Box
                                p={2}
                                bgcolor="#fff"
                                borderRadius={15}
                                mt={1}
                                textAlign="center">
                                <Grid container>
                                    <Hidden only={['xs']}>
                                        <Grid xs={1}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {i + 1}
                                            </Box>
                                        </Grid>
                                        <Grid xs={3}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {row.invoiceNumber}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {row.date}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {row.totalPacks}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {globalFuncs.SepratePrice(row.totalSum, 'fa')}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                <RouterLink to={`/unpaid-invoices/${row.invoiceNumber}`} rel="nofollow">نمایش</RouterLink>
                                            </Box>
                                        </Grid>
                                    </Hidden>
                                    <Hidden only={['sm', 'md', 'lg', 'xl']}>
                                        <Grid xs={4}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                style={{ textAlign: 'center' }}
                                                height="100%">
                                                {row.invoiceNumber}
                                            </Box>
                                        </Grid>
                                        <Grid xs={4}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                style={{ textAlign: 'center' }}
                                                height="100%">
                                                {row.totalPacks}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                style={{ textAlign: 'center' }}
                                                height="100%">
                                                {globalFuncs.SepratePrice(row.totalSum, 'fa')}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                justifyContent="center"
                                                alignItems="center"
                                                textAlign="center"
                                                style={{ textAlign: 'center' }}
                                                height="100%">
                                                <RouterLink to={`/unpaid-invoices/${row.invoiceNumber}`} rel="nofollow">نمایش</RouterLink>
                                            </Box>
                                        </Grid>
                                    </Hidden>
                                </Grid>
                            </Box>
                        ))}

                </Box>
            </div>
        </>
    );
}

export default UnPaidInvoices